// @ts-nocheck
import {
  Box,
  Card,
  Checkbox,
  CircularProgress,
  ClickAwayListener,
  Fade,
  FormControl,
  FormControlLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  styled,
} from "@mui/material";
import Header from "../../partials/header";
import LeftSidebar from "../../partials/leftSidebar";
import searchIcon from "../../../assets/images/icon/search.svg";
import gridIcon from "../../../assets/images/icon/userGrid-view.svg";
import listIcon from "../../../assets/images/icon/userList-view.svg";
import phoneIcon from "../../../assets/images/icon/phoneIcon.svg";
import mailIcon from "../../../assets/images/icon/mailIcon.svg";
import threeDotsIcon from "../../../assets/images/icon/threedots.png";
import editIcon from "../../../assets/images/icon/edit.png";
import deleteIcon from "../../../assets/images/icon/delete.png";
import { makeStyles } from "@mui/styles";
import { useCallback, useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import ProfileAvatar from "../../user/ProfileAvatar";
import AntSwitch from "../../sharedComponent/AntSwitch";
import UserCardGrid from "./UserCardGrid";
import closeIcon from "../../../assets/images/close.svg";
import PhoneInput from "react-phone-input-2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IconLayoutGrid } from '@tabler/icons-react';
import {ViewList} from "@icon-park/react"
import CloseIcon from "@mui/icons-material/Close";
import {
  ActivateAndSuspenduser,
  addBulkPartnerUsers,
  deletePartnerUsers,
  getPartnerRoles,
  getPartnerUsers,
  updatePartnerUsers,
} from "../../../services/api/userRolesApi";
import { ToastContext, useToastContext } from "../../../context/toastContext";
import Loading from "../../loading";
import ConfirmationModal from "./ConfirmationModal";
import InfoHoverTooltip from "../../Tooltips/InfoHover";
import { PROFILE_TYPE } from "../../../helper/globalConstant";
import DownloadIcon from '@mui/icons-material/Download';
import { getMethod } from "../../../services/apiService";
import "../../user/Users.css";
import SearchIcon from '@mui/icons-material/Search';
import EditBlueIcon from "../../icons/EditBlueIcon";
const useStyles = makeStyles({
  toggleBtnsGrp: {
    border: "1px solid #5A5F60",
    borderRadius: "30px !important",
    "& .toggle-switch": {
      backgroundColor: "transparent",
      display: "flex",
      alignItems: "center",
      background: "#1f2f34",
      borderRadius: "30px",
      padding: "6px 10px",
    },
  },
  formControl: {
    width: "100%",
    "& .MuiSelect-select": {
      backgroundColor: "#1F2F34",
      borderRadius: "30px",
      padding: "8px 20px 8px 16px",
      fontSize: "14px",
      fontWeight: 400,
      border: "1px solid #5A5F60",
      outline: "none",
      width: "100%",
      color: "#A5A8A9",
      "&:hover": {
        border: "1px solid #5A5F60",
      },
      "&:focus": {
        border: "1px solid #5A5F60",
        outline: "none",
        boxShadow: "none",
        borderRadius: "30px",
      },
      "&.MuiSelect-selectMenu": {
        "&:before, &:after": {
          display: "none",
        },
      },
    },
  },
  menuItem: {
    backgroundColor: "#1F2F34",
    borderRadius: "4px",
    fontSize: "14px",
    padding: "12px 16px",
    minWidth: "143px",
    "&:hover": {
      backgroundColor: "#0B4A62",
    },
  },
  selectedMenuItem: {
    backgroundColor: "#0B4A62",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#0B4A62",
    },
  },
  checkbox: {
    padding: 0,
    marginRight: "12px",
    "& .MuiSvgIcon-root": {
      fill: "#E2E3E3",
      height: "20px",
      width: "20px",
    },
    "&:hover .MuiSvgIcon-root": {
      fill: "#17B2EB",
    },
    "&.Mui-checked .MuiSvgIcon-root": {
      fill: "#17B2EB",
    },
    "&.Mui-disabled": {
      fill: "currentColor",
      opacity: "0.3",
      cursor: "not-allowed",
    },
  },
  radio: {
    "& .MuiSvgIcon-root": {
      fill: "#E2E3E3",
      height: "20px",
      width: "20px",
    },
    "&:hover .MuiSvgIcon-root": {
      fill: "#17B2EB",
    },
    "&.Mui-checked .MuiSvgIcon-root": {
      fill: "#17B2EB",
    },
  },
  userTableBG: {
    background: "transparent !important",
    borderRadius: "50px",
  },
});

type PhoneNumberState = { number: string; error: string };

interface UserData {
  userId: string;
  profileId: number;
  superadmin: boolean;
  name: string;
  lastName: string;
  address: Address;
  mailId: string;
  mobile: string;
  sequrityQuestion1?: string;
  sequrityAnswer1?: string;
  sequrityQuestion2?: string;
  sequrityAnswer2?: string;
  lastLoginTime: number;
  logedId: boolean;
  machineUser: number;
  sites: any[];
  enterprises: any[];
  accountStatus: string;
  profilePhoto: string;
}

interface Address {
  state: string;
}

interface FormData {
  name: string;
  lastName: string;
  mailId: string;
  mobile: string;
  role: string;
  profileId: string;
  emailMessage: string;
}

interface Role {
  profileId: number;
  profileName: string;
  priority: number;
  ownerId?: string;
}

const UsersTab = ({ entityType }: { entityType?: string }) => {

  const classes = useStyles();

  const { setToast } = useToastContext() as ToastContext;

  const [view, setView] = useState<"table" | "grid">("grid");
  const [activeTab, setActiveTab] = useState("grid");
  const [setData, setUserData] = useState<[]>([]);
  const [search, setSearch] = useState<string>("");
  const [dropdownVisible, setDropdownVisible] = useState<number | string | null>(null);
  const [openModal1, setOpenModal1] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    lastName: "",
    mailId: "",
    mobile: "",
    profileId: 0,
    emailMessage: "",
    redirecturl: "",
    profileName: "",
  });

  const [editFormData, setEditFormData] = useState({
    name: "",
    lastName: "",
    mailId: "",
    mobile: "",
    profileId: 0,
    userId: "",
    redirecturl: "",
    profileName: "",
  });

  const [rolesVisible, setRolesVisible] = useState(false);
  const [errors, setErrors] = useState<Partial<FormData>>({});
  const [selectedRole, setSelectedRole] = useState<string>("");
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [checkedAllUser, setCheckedAllUser] = useState(false);
  const [checkedIds, setCheckedIds] = useState<string[]>([]);
  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>(
    {}
  );
  const [selectedCount, setSelectedCount] = useState(0);
  const [activeUser, setActiveUser] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [loggedInUser, setIsloggedInUser] = useState(false);
  const [activeModalTab, setActiveModalTab] = useState("userDetails");
  const [allRoles, setAllRoles] = useState<Role[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [userDeleteId, setUserDeleteId] = useState<any>(null);
  const [userDataCopy, setUserDataCopy] = useState<[]>([])
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [downloadingPartnerId, setDownloadingPartnerId] = useState<string | null>(null);

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const [phoneNumber, setPhoneNumber] = useState<PhoneNumberState>({ number: "", error: "" });

  const validateForm = (data: any) => {
    let errors: Partial<FormData> = {};
    if (!data.name) {
      errors.name = "First name is required";
    }
    if (!data.lastName) {
      errors.lastName = "Last Name is required";
    }
    if (!data.mailId) {
      errors.mailId = "Email ID can't be empty";
    } else if (!emailPattern.test(data.mailId)) {
      errors.mailId = "Please provide correct email pattern";
    }
    if (!data.mobile) {
      errors.mobile = "Mobile number can't be empty";
    }

    if (entityType === "technicians" && !data.profileId) {
      errors.profileId = "Please select a role";
    }
    return errors;
  };

  const handleTabClick = (tabName: string) => {
    if (tabName !== activeTab) {
      setActiveTab(tabName);
    }
  };

  const downloadLicense = useCallback(async (partnerId: string) => {
    if (partnerId) {
      setDownloadingPartnerId(partnerId);
      try {
        const resp = await getMethod(`distributor/license/key/${partnerId}`);
        if (resp?.status === 200 && resp.data) {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${partnerId}.key`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setToast("License downloaded successfully", "success");
        } else {
          setToast(resp?.data?.message || "Failed to download license key. Please try again.", "error");
        }
      } catch (error) {
        console.error("Error downloading license key:", error);
        setToast("An error occurred during license download. Please try again.", "error");
      } finally {
        setDownloadingPartnerId(null);
      }
    }
  }, [setToast]);

  const fetchPartnerRoles = useCallback(async () => {
    try {
      const response = await getPartnerRoles();

      if (response.status === 200) {
        const roles = (response.data?.result as Role[] || []).map((role) => {
          if (role.priority === PROFILE_TYPE.INTEGRATOR || role?.profileName?.toLowerCase() === "integrator") {
            return {
              ...role,
              profileName: "Partner",
            };
          }
          return role;
        });
        setAllRoles(roles);
        setIsLoading(false);
      } else {
        setToast(response?.message, "error");
        setIsLoading(false);
      }

    } catch (err) {
      setToast(response?.message, "error");
      setIsLoading(false);
    }
  }, [setAllRoles])

  const fetchPartnerUsers = useCallback(async () => {
    try {
      const response = await getPartnerUsers();
      if (response.status == 200) {
        setUserData(response.data?.result);
        setUserDataCopy(response.data?.result)
      } else {
        setToast(response?.message, "error");
      }
    } catch (err) {
      console.log("Error ->", err);
      setToast(response?.message, "error");
    }
  }, [setUserDataCopy, setUserData]);

  useEffect(() => {
    fetchPartnerRoles();
    fetchPartnerUsers();
  }, []);

  const breadCrumb = [
    {
      label: "Admin",
      path: "/admin",
    },
    {
      label: "Users",
      path: "/admin/users",
    },
  ];

  const handleFilter = (id: string | number) => {
    if (id !== "ALL") {
      let usersList = userDataCopy.filter(((val: any) => val.profileId == id))
      if (search) {
        let searchedData = usersList.filter(
          (item: any) => {
            let fullName: any;
            if (item.name && item.lastName) {
              fullName = `${item.name} ${item.lastName}`.toLowerCase();
            } else if (item.name) {
              fullName = `${item.name}`.toLowerCase();
            }
            return fullName.toLowerCase().includes(search) ||
              (item?.mobile?.includes(search)) ||
              (item?.mailId?.toLowerCase()?.includes(search))
          }
        );
        setUserData(usersList)
      } else {
        setUserData(usersList)
      }
    } else {
      setUserData(userDataCopy)
    }
  };

  const handleChangeSwitch = (userId: string, type: string) => async (event: any) => {
    const checked = event.target.checked;
    const updatedStatus = checked ? "ACTIVE" : "SUSPENDED";
    let payload = {
      userid: userId,
    };

    try {
      const response = await ActivateAndSuspenduser(type, payload);
      if (response?.status == 200) {
        const newData = [...setData];
        const userIndex = newData.findIndex(user => user.userId === userId);

        newData[userIndex].accountStatus = updatedStatus;
        setUserData(newData);
        fetchPartnerUsers();
        setToast(response.data?.message, "success");
      } else {
        setToast(response.data?.message, "error");
      }
    } catch (err) {
      setToast("API ERROR updating account status", "error");
    }
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value?.toLowerCase());

  const handleToggleDropdown = (id: any) => setDropdownVisible((prevId) => (prevId === id ? null : id));

  const openAddModal = () => setOpenModal1(true);

  const openDeleteModal = (id: any) => {
    setConfirmationModalOpen(true);
    setUserDeleteId(id);
  };
  const openEditModal = (userId: any) => {
    const userInfo: any = setData.find((data) => data?.userId === userId);
    let roleName: any = allRoles.find(
      (res) => res?.profileId === userInfo?.profileId
    );

    setOpenModal2(true);
    setEditFormData({
      userId: userInfo.userId,
      name: userInfo.name,
      lastName: userInfo.lastName,
      mailId: userInfo.mailId,
      mobile: userInfo.mobile,
      profileId: userInfo.profileId,
      redirecturl: "",
      profileName: roleName?.profileName,
    });
    setSelectedRole(roleName?.profileName);
  };

  const handleCloseModal = () => {
    setOpenModal1(false);
    setOpenModal2(false);
    setOpenModal3(false);
    setFormData({
      name: "",
      lastName: "",
      mailId: "",
      mobile: "",
      profileId: 0,
      emailMessage: "",
      profileName: "",
      redirecturl: "/set-password?uk=",
    });
    setEditFormData({
      name: "",
      lastName: "",
      mailId: "",
      mobile: "",
      profileId: 0,
      userId: "",
      emailMessage: "",
      profileName: "",
    });
    setSelectedRole("");
    let errors: Partial<FormData> = {};
    setErrors(errors);
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (name === "name") {
      errors.name = "";
    } else if (name === "lastName") {
      errors.lastName = "";
    } else if (name === "mobile") {
      errors.mobile = "";
    } else if (name === "mailId") {
      if (!emailPattern.test(value)) {
        errors.mailId = "Please provide correct email pattern";
      } else {
        errors.mailId = "";
      }
    }

    else if (name === "profile") {
      errors.emailMessage = "";
    }

    if (openModal2) {
      setEditFormData({ ...editFormData, [name]: value });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleNumber = (number: any, trimmedNumber: any, type: string) => {
    if (type === "create") {
      setFormData({ ...formData, mobile: number });
    } else {
      setEditFormData({ ...editFormData, mobile: number });
    }
    validatePhoneNumber(trimmedNumber);
  };

  const validatePhoneNumber = (phoneNumber: string) => {
    // This pattern allows an optional + followed by 10 to 15 digits, covering most international formats.
    const phonePattern = /^\+?\d{10,15}$/;

    if (!phonePattern.test(phoneNumber)) {
      setPhoneNumber((prev) => ({
        ...prev,
        number: phoneNumber,
        error: "Invalid phone number",
      }));
      setErrors((prev) => ({
        ...prev,
        mobile: "Invalid phone number",
      }));
    } else {
      setPhoneNumber((prev) => ({
        ...prev,
        number: phoneNumber,
        error: "",
      }));
      setErrors((prev) => ({
        ...prev,
        mobile: "",
      }));
    }
  };

  const toggleRolesDropdown = () => {
    setRolesVisible(!rolesVisible);
  };

  const handleAllCheckBox = (e: any) => {
    const newCheckedIds: string[] = [];
    if (e.target.checked) {
      setData.filter((item: any) => {
        setCheckedItems((prevState) => ({
          ...prevState,
          [item.userId]: !prevState[item.userId],
        }));
        newCheckedIds.push(item.userId);
      });
      setCheckedAllUser(true);
      setSelectedCount(setData.length);
      setCheckedIds((prevCheckedIds) => [...prevCheckedIds, ...newCheckedIds]);
    } else {
      setSelectedCount(0);
      setCheckedItems({});
      setCheckedIds([]);
      setCheckedAllUser(false);
    }
  };

  const isActiveUserMatch = () => {
    if (!searchQuery) return true;

    let fullName = "";
    if (activeUser.name && activeUser.lastName) {
      fullName = `${activeUser.name} ${activeUser.lastName}`.toLowerCase();
    } else if (activeUser.name) {
      fullName = activeUser.name.toLowerCase();
    }

    return (
      fullName.includes(searchQuery) ||
      (activeUser?.phone && activeUser?.phone?.includes(searchQuery)) ||
      (activeUser?.email &&
        activeUser?.email?.toLowerCase()?.includes(searchQuery))
    );
  };

  const handleCheckboxChange = (id: string) => {
    const newCheckedItems = { ...checkedItems, [id]: !checkedItems[id] };
    setCheckedItems(newCheckedItems);
    const count = Object.values(newCheckedItems).filter(Boolean).length;
    if (count === setData.length) {
      setCheckedAllUser(true);
    } else {
      setCheckedAllUser(false);
    }
    setSelectedCount(count);
    if (checkedIds.includes(id)) {
      const updatedIds = checkedIds.filter((checkedId) => checkedId !== id);
      setCheckedIds(updatedIds);
    } else {
      setCheckedIds([...checkedIds, id]);
    }
  };
  const handleModalTabClick = (tab: any) => {
    setActiveModalTab(tab);
  };

  const handleUsernameClick = (id: any) => {
    handleCheckboxChange(id);
  };

  const getRoleNameByProfileId = (id: number) => {
    let a = allRoles.find((role) => role.profileId === id);
    if (a) {
      return a.profileName;
    } else {
      return "N/A";
    }
  };

  const handleRoleChange = (name: string, id: number) => {
    setSelectedRole(name);
    if (openModal2) {
      const updatedFormData = {
        ...editFormData,
        profileId: id,
        profileName: name,
      };
      setEditFormData(updatedFormData);
    } else {
      const updatedFormData = {
        ...formData,
        profileId: id,
        profileName: name,
      };
      setFormData(updatedFormData);
    }
    errors.profileId = "";
  };

  const handleSubmit = async (e: any, type: string) => {
    e.preventDefault();

    const validationErrors = validateForm(formData);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setIsSubmitting(true);
      try {
        let payload = {};
        let finalFormData = { ...formData };

        if (entityType !== "technicians" && !finalFormData.profileId) {
          if (allRoles.length > 0) {
            finalFormData.profileId = allRoles[0].profileId;
            finalFormData.profileName = allRoles[0].profileName;
          } else {
            if (entityType === "distributors") {
              finalFormData.profileId = PROFILE_TYPE.DISTRIBUTOR;
              finalFormData.profileName = "Distributor";
            } else if (entityType === "partners") {
              finalFormData.profileId = PROFILE_TYPE.INTEGRATOR;
              finalFormData.profileName = "Partner";
            }
          }
        }

        let payloadData = {
          ...finalFormData,
          name: finalFormData.name.trim(),
          lastName: finalFormData.lastName.trim(),
          mailId: finalFormData.mailId.trim(),
          mobile: finalFormData.mobile.trim(),
          emailMessage: finalFormData.emailMessage.trim(),
          redirecturl: `/set-password?uk=`
        };

        if (payloadData.mobile !== "") {
          payloadData.mobile = `+${payloadData.mobile}`;
        }

        payload = payloadData;

        const response = await addBulkPartnerUsers(payload);

        if (response?.status === 200) {
          setToast(`${allRoles.length > 0 ? allRoles[0].profileName.split(' ')[0] : "User"} added successfully!`, "success");
          setOpenModal1(false);
          fetchPartnerUsers();
          setFormData({
            name: "",
            lastName: "",
            mailId: "",
            mobile: "",
            profileId: 0,
            emailMessage: "",
            redirecturl: "",
            profileName: ""
          });
          setSelectedRole("")
        } else {
          setToast(response?.data?.message, "error");
        }
      } finally {
        setIsSubmitting(false);
      }
    }

  };

  const handleUpdate = async (e: any, type: string) => {
    e.preventDefault();

    const validationErrors = validateForm(editFormData);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setIsSubmitting(true);
      try {
        let payload = {};
        let finalEditFormData = { ...editFormData };

        if (entityType !== "technicians" && !finalEditFormData.profileId) {
          if (allRoles.length > 0) {
            finalEditFormData.profileId = allRoles[0].profileId;
            finalEditFormData.profileName = allRoles[0].profileName;
          } else {
            if (entityType === "distributors") {
              finalEditFormData.profileId = PROFILE_TYPE.DISTRIBUTOR;
              finalEditFormData.profileName = "Distributor";
            } else if (entityType === "partners") {
              finalEditFormData.profileId = PROFILE_TYPE.INTEGRATOR;
              finalEditFormData.profileName = "Partner";
            }
          }
        }

        let payloadData = {
          ...finalEditFormData,
          name: finalEditFormData.name.trim(),
          lastName: finalEditFormData.lastName.trim(),
          mailId: finalEditFormData.mailId.trim(),
          mobile: finalEditFormData.mobile.trim(),
          redirecturl: `/set-password?uk=`
        };

        if (payloadData.mobile !== "") {
          payloadData.mobile = payloadData.mobile.startsWith("+")
            ? payloadData.mobile
            : `+${payloadData.mobile}`;
        }
        var form_data = new FormData();
        form_data.append("name", payloadData.name);
        form_data.append("lastname", payloadData.lastName);
        form_data.append("email", payloadData.mailId);
        form_data.append("profileid", payloadData.profileId);
        form_data.append("mobile", payloadData.mobile);

        form_data.append("redirecturl", `/set-password?uk=`);

        payload = form_data;

        const response = await updatePartnerUsers(editFormData.userId, payload);

        if (response?.status === 200) {
          setToast(`${allRoles.length > 0 ? allRoles[0].profileName.split(' ')[0] : "User"} updated successfully!`, "success");
          setOpenModal2(false);
          fetchPartnerUsers();
          setEditFormData({
            name: "",
            lastName: "",
            mailId: "",
            mobile: "",
            profileId: 0,
            emailMessage: "",
            redirecturl: "",
            profileName: "",
          });
          setSelectedRole("")
        } else {
          setToast(response?.data?.message, "error");
        }
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  useEffect(() => {
    if (isDeleting) deleteUser(userDeleteId);
  }, [isDeleting]);

  const deleteUser = async (id: string) => {
    var payload: string[] = [];
    if (isDeleting) {
      payload.push(id)
    }
    const response = await deletePartnerUsers(payload);
    if (response?.status === 200) {
      setIsDeleting(false);
      setToast(response?.data?.message, "success");
      fetchPartnerUsers()
    } else {
      setToast(response?.data?.message, "error");
    }
  };
  const styleModal = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minWidth: "650px",
    backgroundColor: "#1D292E",
    border: "1px solid #5A5F60",
    borderRadius: "32px",
    padding: "32px",
    outline: "none",
  };


  const displayFullName = (firstName: string, lastName: string) => {
    let fullName = firstName + " " + lastName;

    if (fullName.length > 30) {
      fullName = fullName.slice(0, 30) + "...";
    }
    return fullName;
  };

  const displayEmail = (email: string) => (email.length > 30 ? email.slice(0, 30) + "..." : email);

  const filteredData = setData?.filter((userData) =>
    userData?.name?.toLowerCase()?.includes(search.toLowerCase())
    || userData?.lastName?.toLowerCase()?.includes(search.toLowerCase())
    || userData?.mailId?.toLowerCase()?.includes(search.toLowerCase())
    || userData?.mobile?.includes(search)
  ) || [];

  return (
    <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <Stack
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        style={{ paddingBottom: "32px" }}
      >
        <div></div>
        <Stack
          display="flex"
          flexDirection="row"
          alignItems="center"
          gap="16px"
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <Box
              className="integrations-search"
              sx={{
                width: "100%",
                maxWidth: entityType === "technicians" ? "350px" : "450px",
                flexShrink: 1,
                transition: "max-width 0.3s ease"
              }}
            >
              {/* <img src={searchIcon} alt="Search Icon" className="icon" /> */}
              <SearchIcon className="icon" alt="Search Icon"/>
              <input
                placeholder="Search"
                onChange={handleSearch}
                style={{ width: entityType === "technicians" ? "260px" : "360px" }}
                value={search}
              />
            </Box>
          </div>
          {entityType === "technicians" && (
            <FormControl
              fullWidth
              variant="standard"
              className={classes.formControl}
            >
              <Select
                defaultValue={"ALL"}
                sx={{
                  "&:hover:not(.Mui-disabled, .Mui-error):before": {
                    borderBottom: "none",
                  },
                  "&:focus:not(.Mui-disabled, .Mui-error):before": {
                    borderBottom: "none",
                  },
                  "&:before": {
                    borderBottom: "none",
                  },
                  "&.Mui-focused:after": {
                    borderBottom: "none",
                  },
                }}
                inputProps={{
                  MenuProps: {
                    PaperProps: {
                      sx: {
                        backgroundColor: '#1F2F34 !important'
                      }
                    }
                  }
                }}
              >
                <MenuItem
                  value={"ALL"}
                  className={classes.menuItem}
                  onClick={() => handleFilter("ALL")}
                >
                  All Roles
                </MenuItem>

                {allRoles.map((role: any, index: number) => (
                  <MenuItem
                    key={index}
                    value={role.profileId}
                    className={classes.menuItem}
                    onClick={() => handleFilter(role.profileId)}
                  >
                    {role.profileName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          <ToggleButtonGroup
            value={view}
            exclusive
            onChange={(e, value) => setView(value)}
            className={classes.toggleBtnsGrp}
          >
            <ToggleButton
              value="grid"
              className={
                activeTab === "grid" ? "toggle-switch active" : "toggle-switch"
              }
              onClick={() => handleTabClick("grid")}
              >
              {/* <img src={gridIcon} alt="grid icon" /> */}
              <IconLayoutGrid stroke={2} color="#E2E3E3" size={24}/>
            </ToggleButton>
            <ToggleButton
              value="table"
              className={
                activeTab === "table" ? "toggle-switch active" : "toggle-switch"
              }
              onClick={() => handleTabClick("table")}
            >
              {/* <img src={listIcon} alt="list icon" /> */}
              <ViewList theme="outline" size="24" fill="#E2E3E3" strokeWidth={2.8} style={{marginTop:"6px"}}/>
            </ToggleButton>
          </ToggleButtonGroup>

          <button
            className="add-btn"
            onClick={openAddModal}
            style={{
              cursor: "pointer",
              whiteSpace: "nowrap",
              flexShrink: 0,
              textTransform: "capitalize"
            }}
          >
            Add New {entityType?.slice(0, -1)}
          </button>
        </Stack>
      </Stack>
      <Box
        sx={{
          position: "relative",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden"
        }}
      >
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "calc(100%)",
            }}
          >
            <Loading />
          </Box>
        ) : (
          <>
            {filteredData.length === 0 ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: 'calc(100vh - 250px)',
                  gap: '24px',
                  opacity: 0.9,
                }}
              >
                <Box
                  sx={{
                    width: '140px',
                    height: '140px',
                    borderRadius: '50%',
                    background: 'rgba(23, 178, 235, 0.03)', // Simple flat background
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid rgba(23, 178, 235, 0.1)'
                  }}
                >
                  {/* <img src={searchIcon} style={{ width: '60px', opacity: 0.2, filter: 'brightness(1.2)' }} /> */}
                  <SearchIcon style={{ width: '60px', opacity: 0.2, filter: 'brightness(1.2)' }}/>
                </Box>
                <Stack alignItems="center" spacing={1.5}>
                  <Typography sx={{ color: '#fff', fontSize: '22px', fontWeight: 600, letterSpacing: '0.5px', textTransform: "capitalize" }}>
                    {setData.length === 0
                      ? `No ${allRoles.length > 0 ? allRoles[0].profileName.split(' ')[0] : entityType?.slice(0, -1)} found`
                      : "No matching results"}
                  </Typography>
                  <Typography sx={{ color: '#A5A8A9', fontSize: '15px', textAlign: 'center', maxWidth: '340px', lineHeight: 1.6 }}>
                    {setData.length === 0
                      ? `Get started by adding your first ${allRoles.length > 0 ? allRoles[0].profileName.split(' ')[0].toLowerCase() : entityType?.slice(0, -1).toLowerCase()}.`
                      : "Try adjusting your search filters."}
                  </Typography>
                </Stack>
                {setData.length === 0 && (
                  <button
                    className="add-btn"
                    onClick={openAddModal}
                    style={{
                      padding: '12px 32px',
                      fontSize: '15px',
                      fontWeight: 500,
                      marginTop: '8px',
                      textTransform: "capitalize"
                    }}
                  >
                    Add New {allRoles.length > 0 ? allRoles[0].profileName.split(' ')[0] : entityType?.slice(0, -1)}
                  </button>
                )}
              </Box>
            ) : (
              <>
                {activeTab === "grid" && (
                  <Box sx={{ flexGrow: 1, overflow: "auto", marginTop: "20px" }}>
                    <Grid
                      container
                      spacing={2}
                    >
                      {filteredData.map((user, index) => (
                        <Grid size={{ xs: 12, md: 6, lg: 3 }} key={user.userId}>
                          <UserCardGrid
                            index={index}
                            user={user}
                            key={index}
                            handleChangeSwitch={handleChangeSwitch(
                              user.userId,
                              user.accountStatus === "ACTIVE"
                                ? "suspend"
                                : "activate"
                            )}
                            checked={user.accountStatus === "ACTIVE" ? true : false}
                            openEditModal={(userId) => openEditModal(userId)}
                            openDeleteModal={() => openDeleteModal(user.userId)}
                            allRoles={allRoles}
                            entityType={entityType}
                            handleDownloadLicense={downloadLicense}
                            isDownloading={downloadingPartnerId === user.userId}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                )}
                {/* TABLE VIEW  */}
                {activeTab === "table" && (
                  <TableContainer
                    style={{
                      position: "relative",
                      maxHeight: "calc(100vh - 170px)",
                      overflowY: "auto",
                    }}
                  >
                    <Table className={`userTable ${classes.userTableBG}`}>
                      <TableHead style={{ borderBottom: "2px solid #5A5F60" }}>
                        <TableRow>
                          <TableCell className="tableHeading">
                            User Name
                          </TableCell>
                          <TableCell className="tableHeading">User ID</TableCell>
                          <TableCell className="tableHeading">Contact Number</TableCell>
                          <TableCell className="tableHeading">User Role</TableCell>
                          <TableCell className="tableHeading">Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredData.map((user, index) => (
                          <TableRow
                            key={user.userId}
                            style={{
                              opacity: user.accountStatus === "ACTIVE" ? "1" : "0.4",
                            }}
                          >
                            <TableCell className="tableData">
                              <Stack
                                display="flex"
                                flexDirection="row"
                                alignItems="center"
                                gap="16px"
                              >
                                {user.profilePhoto ? (
                                  <img
                                    src={user.profilePhoto}
                                    alt="user"
                                    className="icon"
                                    height={52}
                                    width={52}
                                  />
                                ) : (
                                  <ProfileAvatar
                                    firstName={user.name}
                                    lastName={user.lastName}
                                  />
                                )}
                                <span
                                  onClick={() => handleUsernameClick(user.userId)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <InfoHoverTooltip title={user.name + " " + user.lastName} arrowDirection="top">
                                    {displayFullName(user.name, user.lastName)}
                                  </InfoHoverTooltip>
                                </span>
                              </Stack>
                            </TableCell>
                            <TableCell className="tableData">
                              <InfoHoverTooltip title={user.mailId} arrowDirection="top">
                                {displayEmail(user.mailId)}
                              </InfoHoverTooltip>
                            </TableCell>
                            <TableCell className="tableData">{user.mobile}</TableCell>
                            <TableCell className="tableData">
                              {getRoleNameByProfileId(user.profileId)}
                            </TableCell>
                            <TableCell className="tableData">
                              <Stack direction="row" alignItems="center" spacing={1}>
                                <Box
                                  display="flex"
                                  flexDirection="row"
                                  alignItems="center"
                                  paddingRight="19px"
                                  borderRight={
                                    user.accountStatus === "ACTIVE"
                                      ? "1px solid #313838"
                                      : ""
                                  }
                                  margin="3px 0px"
                                >
                                  <FormControlLabel
                                    control={
                                      <AntSwitch
                                        checked={
                                          user.accountStatus === "ACTIVE" ? true : false
                                        }
                                        onClick={handleChangeSwitch(
                                          user.userId,
                                          user.accountStatus === "ACTIVE"
                                            ? "suspend"
                                            : "activate"
                                        )}
                                        inputProps={{ "aria-label": "ant design" }}
                                      />
                                    }
                                    label={""}
                                  />
                                </Box>

                                {user.accountStatus === "ACTIVE" && (
                                  <InfoHoverTooltip
                                    title={"Edit"}
                                    arrowDirection="bottom"
                                  >
                                    {/* <img
                                      src={'/icons/edit-blue-icon.svg'}
                                      alt="edit icon"
                                      className="icon"
                                      style={{ width: "20px", height: "20px" }}
                                      onClick={() => openEditModal(user.userId)}
                                    /> */}
                                    <EditBlueIcon 
                                    onClick={() => openEditModal(user.userId)}
                                    style={{ width: "20px", height: "20px" }}
                                    className="icon"
                                    />
                                  </InfoHoverTooltip>
                                )}

                                {entityType === "distributors" && user.accountStatus === "ACTIVE" && (
                                  <InfoHoverTooltip
                                    title={downloadingPartnerId === user.userId ? "Downloading..." : "Download license key"}
                                    arrowDirection="bottom"
                                  >
                                    <Box component="span" sx={{ display: "inline-flex", alignItems: "center" }}>
                                      {downloadingPartnerId === user.userId ? (
                                        <CircularProgress
                                          size={20}
                                          sx={{
                                            color: "#17b2eb",
                                            marginLeft: "5px",
                                          }}
                                        />
                                      ) : (
                                        <DownloadIcon
                                          sx={{
                                            color: "#17b2eb !important",
                                            fontSize: 24,
                                            stroke: "#17b2eb",
                                            fill: "#17b2eb",
                                            marginLeft: "5px",
                                            width: "20px",
                                            height: "20px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            downloadLicense(user.userId)
                                          }
                                        />
                                      )}
                                    </Box>
                                  </InfoHoverTooltip>
                                )}
                                {entityType === "technicians" && user.accountStatus === "ACTIVE" && (
                                  <InfoHoverTooltip
                                    title={"Delete"}
                                    arrowDirection="bottom"
                                  >
                                    <img
                                      src={deleteIcon}
                                      alt="delete icon"
                                      className="icon"
                                      style={{ marginLeft: "5px" }}
                                      onClick={() => openDeleteModal(user.userId)}
                                    />
                                  </InfoHoverTooltip>
                                )}
                              </Stack>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </>
            )}
          </>
        )}
      </Box>

      {/* ADD NEW USER FORMS  */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal1}
        onClose={handleCloseModal}
        closeAfterTransition
        className="customMuiModal"
      >
        <Fade in={openModal1}>
          <Box sx={styleModal}>
            <Stack
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between"
              style={{
                borderBottom: "1px solid #5A5F60",
                paddingBottom: "15px",
                marginBottom: "40px",
              }}
            >
              <Typography className="modalHeading" style={{ textTransform: "capitalize" }}>Add New {entityType?.slice(0, -1)}</Typography>

              {/* <img
                src={closeIcon}
                alt="close icon"
                onClick={handleCloseModal}
                className="icon"
              /> */}
              <CloseIcon onClick={handleCloseModal} className="icon"/>
            </Stack>
            <Box>
              <div>
                {
                  <form
                    style={
                      {
                        overflowY: "auto",
                        scrollbarWidth: "none",
                        "-ms-overflow-style": "none",
                        "&::-webkit-scrollbar": {
                          display: "none",
                        },
                      } as any
                    }
                  >
                    <Stack
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      sx={{
                        marginBottom: "20px",
                      }}
                    >
                      <Box
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Box
                          sx={{ display: "flex", width: "100%", gap: "16px" }}
                        >
                          <div style={{ width: "50%", position: "relative" }}>
                            <label
                              htmlFor="firstName"
                              className="modalFormLabel"
                            >
                              First Name{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              id="firstName"
                              placeholder="Enter First Name "
                              className={`modalForm-input`}
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              autoComplete="off"
                            />
                          </div>
                          <div style={{ width: "50%" }}>
                            <label
                              htmlFor="lastName"
                              className="modalFormLabel"
                            >
                              Last Name{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>{" "}
                            <input
                              type="text"
                              id="lastName"
                              placeholder="Enter Last Name "
                              name="lastName"
                              className={`modalForm-input`}
                              value={formData.lastName}
                              onChange={handleChange}
                              autoComplete="off"
                            />
                          </div>
                        </Box>
                        {(errors.name || errors.lastName) && (
                          <div
                            className="error-message"
                            style={{ paddingTop: "6px" }}
                          >
                            {errors.name && errors.lastName ? "First and last name can't be empty" : (errors.name || errors.lastName)}
                          </div>
                        )}
                      </Box>
                    </Stack>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "20px",
                      }}
                    >
                      <Box>
                        <label htmlFor="emailId" className="modalForm-label">
                          Email ID <span style={{ color: "red" }}>*</span>
                        </label>{" "}
                        <input
                          type="email"
                          id="emailId"
                          name="mailId"
                          placeholder="Enter Email ID "
                          className={`modalForm-input`}
                          value={formData.mailId}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                      </Box>
                      {errors.mailId && (
                        <div
                          className="error-message"
                          style={{ paddingTop: "6px" }}
                        >
                          {errors.mailId}
                        </div>
                      )}
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "20px",
                      }}
                    >
                      <Box>
                        <label htmlFor="contact" className="modalFormLabel">
                          Mobile Number{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>{" "}
                        <PhoneInput
                          specialLabel=""
                          value={formData.mobile}
                          onChange={(number, country) => {
                            // @ts-ignore
                            const countryCode = country?.dialCode;
                            const trimmedNumber = number.startsWith(
                              countryCode
                            )
                              ? number.slice(countryCode.length)
                              : number;

                            handleNumber(number, trimmedNumber, "create");
                          }}
                          country="us"
                          dropdownClass="user-phone-input-dropdown"
                          containerClass="user-phone-input-container"
                          containerStyle={{
                            marginTop: "12px",
                          }}
                          inputClass={`modalForm-input user-phone-input`}
                          inputStyle={{
                            boxShadow: "none",
                            color: "#fff",
                            border: "1px solid #313838 !important",
                            width: "100%",
                            height: "40px",
                            backgroundColor: "transparent",
                          }}
                        />
                        {errors.mobile && (
                          <div
                            className="error-message"
                            style={{ paddingTop: "6px" }}
                          >
                            {errors.mobile}
                          </div>
                        )}
                      </Box>
                    </Box>

                    {entityType === "technicians" && (
                      <div
                        style={{ marginBottom: "24px", position: "relative" }}
                      >
                        <label htmlFor="rolesBox" className="modalFormLabel">
                          Assign Role <span style={{ color: "red" }}>*</span>
                        </label>{" "}
                        <Stack
                          display="flex"
                          flexDirection="row"
                          alignItems="center"
                          justifyContent="space-between"
                          className={`${errors.profileId ? "errors" : ""
                            } modalForm-input`}
                          style={{
                            marginBottom: "-10px",
                            cursor: "pointer",
                          }}
                          onClick={toggleRolesDropdown}
                        >
                          <span className="selectedValue">
                            {selectedRole || "Select Role"}
                          </span>
                          <ExpandMoreIcon
                            sx={{
                              cursor: "pointer",
                              color: "#B4B7B8",
                              fontSize: "24px",
                              display: "inline-block",
                              transition: "0.5s",
                            }}
                          />
                        </Stack>
                        {rolesVisible && (
                          <ClickAwayListener
                            onClickAway={() => setRolesVisible(false)}
                          >
                            <div
                              className="modalForm-menu"
                              id="sitesBox"
                              style={{
                                position: "absolute",
                                width: "100%",
                                maxHeight: "210px",
                                overflow: "auto",
                                scrollbarWidth: "none",
                                zIndex: 9,
                              }}
                            >
                              <FormControl>
                                <RadioGroup
                                  aria-labelledby="demo-radio-buttons-group-label"
                                  name="radio-buttons-group"
                                  value={selectedRole}
                                >
                                  {allRoles.map((role, index) => (
                                    <FormControlLabel
                                      key={index}
                                      value={role.profileName}
                                      control={
                                        <Radio className={classes.radio} />
                                      }
                                      label={role.profileName}
                                      onClick={() => {
                                        handleRoleChange(
                                          role.profileName,
                                          role?.profileId
                                        );
                                        setRolesVisible(() => false);
                                      }}
                                    />
                                  ))}
                                </RadioGroup>
                              </FormControl>
                            </div>
                          </ClickAwayListener>
                        )}
                        {errors.profileId && (
                          <div className="dropdown-error-message">
                            {errors.profileId}
                          </div>
                        )}
                      </div>
                    )}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "20px",
                      }}
                    >
                      <Box>
                        <label
                          htmlFor="emailMessage"
                          className="modalFormLabel"
                        >
                          Email Message (optional)
                        </label>
                        <input
                          type="email"
                          id="emailMessage"
                          name="emailMessage"
                          placeholder="Enter Email Message "
                          className={`modalForm-input`}
                          value={formData.emailMessage}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                        {errors.emailMessage && (
                          <div
                            className="error-message"
                            style={{ paddingTop: "6px" }}
                          >
                            {errors.emailMessage}
                          </div>
                        )}
                      </Box>
                    </Box>
                  </form>
                }
              </div>

              {
                <div>
                  <Stack
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="flex-end"
                    gap="12px"
                  >
                    <button
                      type="button"
                      className="outline-btn-disable"
                      onClick={handleCloseModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className={`add-btn save-btn ${isSubmitting ? 'btn-disabled' : ''}`}
                      onClick={(e) => handleSubmit(e, "user")}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <Stack direction="row" alignItems="center" gap="8px">
                          <CircularProgress size={16} sx={{ color: "white" }} />
                          <span>Saving...</span>
                        </Stack>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </Stack>
                </div>
              }
            </Box>
          </Box>
        </Fade>
      </Modal>

      {/* EDITUSER FORMS  */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal2}
        onClose={handleCloseModal}
        closeAfterTransition
        className="customMuiModal"
      >
        <Fade in={openModal2}>
          <Box sx={styleModal}>
            <Stack
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between"
              style={{
                borderBottom: "1px solid #5A5F60",
                paddingBottom: "15px",
                marginBottom: "40px",
              }}
            >
              <Typography className="modalHeading" style={{ textTransform: "capitalize" }}>Edit {entityType?.slice(0, -1)}</Typography>
              {/* <img
                src={closeIcon}
                alt="close icon"
                onClick={handleCloseModal}
                className="icon"
              /> */}
              <CloseIcon onClick={handleCloseModal} className="icon"/>
            </Stack>
            <Box>
              <div>
                <div>
                  {
                    <form
                      style={
                        {
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          "-ms-overflow-style": "none",
                          "&::-webkit-scrollbar": {
                            display: "none",
                          },
                        } as any
                      }
                    >
                      <Stack
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        sx={{
                          marginBottom: "20px",
                        }}
                      >
                        <Box
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Box
                            sx={{ display: "flex", width: "100%", gap: "16px" }}
                          >
                            <div style={{ width: "50%", position: "relative" }}>
                              <label
                                htmlFor="firstName"
                                className="modalFormLabel"
                              >
                                First Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>{" "}
                              <input
                                type="text"
                                id="firstName"
                                placeholder="Enter First Name "
                                className={`modalForm-input`}
                                name="name"
                                value={editFormData.name}
                                onChange={handleChange}
                                autoComplete="off"
                              />
                            </div>
                            <div style={{ width: "50%" }}>
                              <label
                                htmlFor="lastName"
                                className="modalFormLabel"
                              >
                                Last Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>{" "}
                              <input
                                type="text"
                                id="lastName"
                                placeholder="Enter Last Name "
                                name="lastName"
                                className={`modalForm-input`}
                                value={editFormData.lastName}
                                onChange={handleChange}
                                autoComplete="off"
                              />
                            </div>
                          </Box>
                          {(errors.name || errors.lastName) && (
                            <div
                              className="error-message"
                              style={{ paddingTop: "6px" }}
                            >
                              {errors.name && errors.lastName ? "First and last name can't be empty" : (errors.name || errors.lastName)}
                            </div>
                          )}
                        </Box>
                      </Stack>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "20px",
                        }}
                      >
                        <Box>
                          <label htmlFor="emailId" className="modalForm-label">
                            Email ID <span style={{ color: "red" }}>*</span>
                          </label>{" "}
                          <input
                            type="email"
                            id="emailId"
                            name="mailId"
                            placeholder="Enter Email ID "
                            className={`modalForm-input`}
                            value={editFormData.mailId}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </Box>
                        {errors.mailId && (
                          <div
                            className="error-message"
                            style={{ paddingTop: "6px" }}
                          >
                            {errors.mailId}
                          </div>
                        )}
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "20px",
                        }}
                      >
                        <Box>
                          <label htmlFor="contact" className="modalFormLabel">
                            Mobile Number{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>{" "}
                          <PhoneInput
                            specialLabel=""
                            value={editFormData.mobile}
                            onChange={(number, country) => {
                              // @ts-ignore
                              const countryCode = country?.dialCode;
                              const trimmedNumber = number.startsWith(
                                countryCode
                              )
                                ? number.slice(countryCode.length)
                                : number;

                              handleNumber(number, trimmedNumber, "edit");
                            }}
                            country="us"
                            dropdownClass="user-phone-input-dropdown"
                            containerClass="user-phone-input-container"
                            containerStyle={{
                              marginTop: "12px",
                            }}
                            inputClass={`modalForm-input user-phone-input`}
                            inputStyle={{
                              boxShadow: "none",
                              color: "#fff",
                              border: "1px solid #313838 !important",
                              width: "100%",
                              height: "40px",
                              backgroundColor: "transparent",
                            }}
                          />
                          {errors.mobile && (
                            <div
                              className="error-message"
                              style={{ paddingTop: "6px" }}
                            >
                              {errors.mobile}
                            </div>
                          )}
                        </Box>
                      </Box>

                      {entityType === "technicians" && (
                        <div
                          style={{ marginBottom: "24px", position: "relative" }}
                        >
                          <label htmlFor="rolesBox" className="modalFormLabel">
                            Assign Role
                          </label>{" "}
                          <Stack
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            justifyContent="space-between"
                            className={`${errors.profileId ? "errors" : ""
                              } modalForm-input`}
                            style={{
                              marginBottom: "-10px",
                              cursor: "pointer",
                            }}
                            onClick={toggleRolesDropdown}
                          >
                            <span className="selectedValue">
                              {selectedRole || "Select Role"}
                            </span>
                            <ExpandMoreIcon
                              sx={{
                                cursor: "pointer",
                                color: "#B4B7B8",
                                fontSize: "24px",
                                display: "inline-block",
                                transition: "0.5s",
                              }}
                            />
                          </Stack>
                          {rolesVisible && (
                            <ClickAwayListener
                              onClickAway={() => setRolesVisible(false)}
                            >
                              <div
                                className="modalForm-menu"
                                id="sitesBox"
                                style={{
                                  position: "absolute",
                                  width: "100%",
                                  maxHeight: "180px",
                                  overflow: "auto",
                                  scrollbarWidth: "none",
                                  zIndex: 9,
                                }}
                                ref={(dropdown) => {
                                  if (dropdown) {
                                    dropdown.scrollIntoView({
                                      behavior: "smooth",
                                      block: "start",
                                    });
                                  }
                                }}
                              >
                                <FormControl>
                                  <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    name="radio-buttons-group"
                                    value={selectedRole}
                                  >
                                    {allRoles.map((role, index) => (
                                      <FormControlLabel
                                        key={index}
                                        value={role.profileName}
                                        control={
                                          <Radio className={classes.radio} />
                                        }
                                        label={role.profileName}
                                        onClick={() => {
                                          handleRoleChange(
                                            role.profileName,
                                            role?.profileId
                                          );
                                          setRolesVisible(() => false);
                                        }}
                                      />
                                    ))}
                                  </RadioGroup>
                                </FormControl>
                              </div>
                            </ClickAwayListener>
                          )}
                          {errors.profileId && (
                            <div className="dropdown-error-message">
                              {errors.profileId}
                            </div>
                          )}
                        </div>
                      )}
                    </form>
                  }
                </div>

                {

                  <Stack
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="flex-end"
                    gap="12px"
                    sx={{
                      marginTop: rolesVisible ? "16px" : "0px"
                    }}
                  >
                    <button
                      type="button"
                      className="outline-btn-disable"
                      onClick={handleCloseModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className={`add-btn save-btn ${isSubmitting ? 'btn-disabled' : ''}`}
                      onClick={(e) => handleUpdate(e, "user")}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <Stack direction="row" alignItems="center" gap="8px">
                          <CircularProgress size={16} sx={{ color: "white" }} />
                          <span>Updating...</span>
                        </Stack>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </Stack>

                }
              </div>
            </Box>
          </Box>
        </Fade>
      </Modal>

      <ConfirmationModal
        open={confirmationModalOpen}
        title="Delete User"
        message={
          "Are you sure you want to delete this user? This action cannot be undone."
        }
        setConfirmation={setIsDeleting}
        setConfirmationModalOpen={setConfirmationModalOpen}
      />
    </Box>
  );
};

export default UsersTab;
